
/* styles */
require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!./../../vue-loader/lib/style-rewriter?id=data-v-450f60ed!./../../vue-loader/lib/selector?type=styles&index=0!./switch-3.vue")

var Component = require("!./../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../vue-loader/lib/selector?type=script&index=0!./switch-3.vue"),
  /* template */
  require("!!./../../vue-loader/lib/template-compiler?id=data-v-450f60ed!./../../vue-loader/lib/selector?type=template&index=0!./switch-3.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loader!./~/vue-markdown-loader/_cache/switch-3.vue
// module id = 219
// module chunks = 0